import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/tipos-de-nominas-empleados';

/**
 * GET Tipos De Nominas Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeNominasEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GETT Tipo de Nomina Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeNominaEmpleado = async (id) => {
  if (!id) return null;
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Nomina Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeNominaEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Nomina Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeNominaEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Nomina Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoDeNominaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Tipo de Nomina Empleado Estatus
 * @param {object} values
 * @returns {Promise<{}>}
 */
export const putTipoDeNominaEmpleado = async (values) => {
  try {
    const response = await API.put('nominas/cierre-de-prenomina', values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};
